/**
 * Santa Eulalia - Novios "Contáctanos" lead form
 * Popup de la sección Image with text SE Novios.
 * Validación: nombre obligatorio + (email O teléfono). Envío AJAX (POST JSON)
 * al API Gateway de services (mismo gateway que devoluciones), con
 * { command: 'novios-contact', ... }. El endpoint llega en el atributo
 * data-endpoint del formulario; el backend gestiona destinatarios.
 */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init() {
    var form = document.getElementById('form-novios-contacto');
    if (!form) return;

    var nameEl = form.querySelector('#novios-contacto-name');
    var emailEl = form.querySelector('#novios-contacto-email');
    var phoneEl = form.querySelector('#novios-contacto-phone');
    var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    var i18n = form.querySelector('#novios-contacto-i18n');
    function msg(name) { return (i18n && i18n.getAttribute('data-' + name)) || ''; }

    function clearError(el) {
      var group = el.closest('.field.form-group') || el.parentNode;
      var err = group.querySelector('.pristine-error');
      if (err) err.remove();
      el.classList.remove('has-danger');
    }

    function setError(el, text) {
      var group = el.closest('.field.form-group') || el.parentNode;
      var err = group.querySelector('.pristine-error');
      if (!err) {
        err = document.createElement('div');
        err.className = 'pristine-error text-help';
        err.setAttribute('role', 'alert');
        err.style.display = 'block';
        err.style.marginTop = '4px';
        group.appendChild(err);
      }
      err.textContent = text;
      el.classList.add('has-danger');
    }

    function showFormMessage(type, text) {
      var old = form.querySelector('.novios-contacto-feedback');
      if (old) old.remove();
      var el = document.createElement('div');
      el.className = 'form-notification novios-contacto-feedback ' + type;
      el.setAttribute('role', type === 'error' ? 'alert' : 'status');
      el.style.marginBottom = '12px';
      el.textContent = text;
      form.insertBefore(el, form.firstChild);
    }

    // Limpiar errores al escribir
    [nameEl, emailEl, phoneEl].forEach(function (el) {
      if (!el) return;
      el.addEventListener('input', function () { clearError(el); });
    });

    function validate() {
      var ok = true;
      clearError(nameEl);
      clearError(emailEl);
      clearError(phoneEl);

      var nameVal = nameEl.value.trim();
      var emailVal = emailEl.value.trim();
      var phoneVal = phoneEl.value.trim();

      if (!nameVal) {
        setError(nameEl, nameEl.getAttribute('data-error-required'));
        ok = false;
      }

      // Email con formato válido si se ha rellenado
      if (emailVal && !EMAIL_RE.test(emailVal)) {
        setError(emailEl, emailEl.getAttribute('data-error-format'));
        ok = false;
      }

      // Al menos uno: email o teléfono
      if (!emailVal && !phoneVal) {
        var contactMsg = msg('msg-contact');
        setError(phoneEl, contactMsg);
        setError(emailEl, contactMsg);
        ok = false;
      }

      return ok;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (!validate()) return;

      var endpoint = form.getAttribute('data-endpoint');
      if (!endpoint) {
        showFormMessage('error', msg('msg-error'));
        return;
      }

      var payload = {
        command: 'novios-contact',
        locale: (typeof Shopify !== 'undefined' && Shopify.locale) ? Shopify.locale : 'es',
        source: 'novios',
        name: nameEl.value.trim(),
        email: emailEl.value.trim(),
        phone: phoneEl.value.trim(),
        comments: form.querySelector('#novios-contacto-comment').value.trim()
      };

      if (submitBtn) submitBtn.disabled = true;

      fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'omit',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json;charset=utf-8', 'X-Requested-With': 'XMLHttpRequest' },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json().catch(function () { return {}; }); })
        .then(function (result) {
          if (result && result.success) {
            form.reset();
            showFormMessage('success', msg('msg-success'));
            var fields = form.querySelector('.novios-contacto-fields');
            if (fields) fields.style.display = 'none';
            var modal = document.getElementById('PopupModal-noviosContacto');
            var title = modal && modal.querySelector('.product-popup-modal__content-header h5');
            if (title) title.style.display = 'none';
          } else {
            showFormMessage('error', (result && result.error) || msg('msg-error'));
            if (submitBtn) submitBtn.disabled = false;
          }
        })
        .catch(function () {
          showFormMessage('error', msg('msg-error'));
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
